import { buildCircuitPathsState } from "../../../../utils/buildCircuitPathsState";
import { STATUS_RGB } from "../../constants";
import type { CircuitPathsState } from "components/SmartSurveyor/ReviewPage/hooks/useCircuitCablePaths/types";
import type { BuildDiffCircuitPathsState } from "./types";

export const buildDiffCircuitPathsState: BuildDiffCircuitPathsState = ({
  diffRoutes,
}) => {
  const allPaths: CircuitPathsState["paths"] = [];
  let totalCableLength = 0;

  for (const diffRoute of diffRoutes) {
    const result = buildCircuitPathsState({
      route: diffRoute.route,
      rgb: STATUS_RGB[diffRoute.status],
    });
    if (result === null) continue;
    allPaths.push(...result.paths);
    totalCableLength += result.totalCableLength ?? 0;
  }

  if (allPaths.length === 0) return null;

  return {
    paths: allPaths,
    distributionBoardPosition: null,
    totalCableLength,
  };
};
